import { useCompareUrlWithProjectId } from 'common/hooks/route';
import { PLANNING_ROUTES } from 'routes/routes.planning.const';
import { KWELLO_ICON } from '../icon/KwelloSvgIcon';
import KwelloIconButton from '../KwelloButton/KwelloIconButton';

const SHOW_NAV_BUTTON_PAGES = [PLANNING_ROUTES.profiles];

function CollectionsNavButton() {
  const { compareUrl } = useCompareUrlWithProjectId();

  if (!SHOW_NAV_BUTTON_PAGES.find((page) => compareUrl(page, { includes: true }))) {
    return null;
  }

  const navigateToCollections = () => {
    // Navigate to collections later
  };

  return (
    <KwelloIconButton
      icon={KWELLO_ICON.BOOKMARK_ICON}
      onClick={navigateToCollections}
      tooltip="Collections"
      tooltipPosition="bottom"
      disabled={true}
    />
  );
}

export default CollectionsNavButton;
